import { AppErrorBoundary } from '@/components/feedback/AppErrorBoundary'
import { RealtimeProvider } from '@/lib/realtime'
import { AuthGate } from './AuthGate'
import { Providers } from './providers'
import { AppRoutes } from './router'

export function App() {
  return (
    <AppErrorBoundary>
      <Providers>
        <a
          href="#conteudo"
          className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[70] focus:rounded-lg focus:bg-primary focus:px-3 focus:py-2 focus:text-sm focus:text-primary-foreground"
        >
          Ir para o conteúdo
        </a>
        <AuthGate>
          <RealtimeProvider>
            <AppRoutes />
          </RealtimeProvider>
        </AuthGate>
      </Providers>
    </AppErrorBoundary>
  )
}
